const PHONE = "+380634059261";
const PHONE_TITLE = "+380 63 405 9261";
const EMAIL = "info@instasport.co";
const PHONE_MIN_LENGTH = 5;

export { EMAIL, PHONE_TITLE, PHONE, PHONE_MIN_LENGTH };
